import { mutationTypes } from "@/store/dashboard/types";

const mutations = {
  [mutationTypes.SET_DYNAMIC_CONTENT_PRICING]: (state, {content}) => {
    state.dynamicContentPricing = JSON.parse(content.value)
  },
  [mutationTypes.SET_DYNAMIC_TRIGGER_PRICING]: (state, {trigger}) => {
    state.dynamicTriggerPricing = JSON.parse(trigger.value)
  },
  [mutationTypes.SET_PAYMENT_INFO]: (state, {data}) => {
    state.paymentInfo = data
  },
  [mutationTypes.SET_YEARLY]: (state, value) => {
    state.isYearly = value;
  },
  [mutationTypes.SET_LOADING_PRICING_PAGE]: (state, value) => {
    state.pricingPageLoading = value;
  },
  TOGGLE_CUSTOM(state, openCustom) {
    state.openCustom = openCustom;
  },
  HIDE_START_GUIDE(state) {
    const orders = state.sectionsOrders.left;
    const startGuide = orders.find(item => item.name === "quickStartGuide");
    startGuide.show = false;
  },
  SET_LOAING(state, loading) {
    state.loading = loading;
  },
  setBFCMBannerClosed(state, value) {
    state.bfcmBannerClosed = value
  }
};

export default mutations;
